import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVfairsComponent } from './simple-icons-vfairs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVfairsComponent ],
    exports:      [ SimpleIconsVfairsComponent ],
    bootstrap:    []
})
export class SimpleIconsVfairsModule {}
